import React, { Component } from 'react'
import PropTypes from 'prop-types'

import employees from '../../data/employees'

import all from '../../images/all.svg'

import './index.css'
import BEMHelper from 'react-bem-helper'
const classes = new BEMHelper('employee')

export default class Employee extends Component {
  static propTypes = {
    who: PropTypes.string.isRequired,
    className: PropTypes.string,
    center: PropTypes.string,
  }

  constructor () {
    super()

    this.head = document.getElementsByTagName('head')[0]
    this.style = null

    this.state = {
      animation: null,
    }
  }

  componentDidMount () {
    if (this.props.who === 'all') {
      this.animateFromElement()
      window.addEventListener('resize', this.animateFromElement)
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.animateFromElement)
    this.clearAnimation()
  }

  clearAnimation = () => {
    if (this.style) {
      this.head.removeChild(this.style)
      this.style = null

      this.setState({
        animation: null,
      })
    }
  }

  makeKeyframe (keyframes) {
    if (this.style) {
      this.head.removeChild(this.style)
    }

    this.style = document.createElement('style')
    this.style.type = 'text/css'
    this.style.innerHTML = keyframes
    this.head.appendChild(this.style)
  }

  animateFromElement = () => {
    if (this.props.who !== 'all') {
      this.clearAnimation()
      return
    }

    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      const { wrapper, image } = this.refs
      const left = wrapper.offsetWidth - image.offsetWidth

      if (left > -50) {
        this.clearAnimation()
        return
      }

      const milliseconds = 1000 + Math.abs(left) * 25

      this.makeKeyframe(
        `
          @keyframes employees {
            50% {
              transform: translateX(${left}px);
            }
          }
        `
      )

      this.setState({
        animation: {
          animation: `employees ${milliseconds}ms linear infinite`,
        },
      })
    }, 300)
  }

  render () {
    const { who, className, center } = this.props
    const { animation } = this.state

    if (who !== 'all') {
      const { image, name } = employees.find(({ id }) => id === who)

      const modifiers = [center ? 'center' : null, who]

      return (
        <figure {...classes('', modifiers, className)}>
          <img {...classes('image')} src={image} alt={name} />
        </figure>
      )
    }
    return (
      <figure {...classes('', 'all', className)} ref="wrapper">
        <img
          {...classes('image')}
          src={all}
          alt="Alle ansatte"
          ref="image"
          style={animation}
        />
      </figure>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Employee/index.js